import(/* webpackMode: "eager" */ "/app/code/apps/web/app/error.tsx");
